import State from '../core/State';
import { AccountStatus } from './../entity/Account';

export const setNewAccountStatus = (status: AccountStatus) => (state: State): State => ({
  ...state,
  new_account: {
    ...state.new_account,
    status,
  },
});
